import request from "@/utils/request";

export function getOperatorList(params) {
    return request({
        url: '/settings/operator/list',
        method: "get",
        params: params
    });
}